import { useTitle } from '@/composables/use-title';

export default function titleHook(to) {
  try {
    useTitle('', to);
  } catch (error) {
    console.error('Error setting title:', error);
  }
  return true;
}
